import { render, staticRenderFns } from "./Assess.vue?vue&type=template&id=0e5c70ac&scoped=true"
import script from "./Assess.vue?vue&type=script&lang=js"
export * from "./Assess.vue?vue&type=script&lang=js"
import style0 from "./Assess.vue?vue&type=style&index=0&id=0e5c70ac&prod&lang=css"
import style1 from "./Assess.vue?vue&type=style&index=1&id=0e5c70ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c70ac",
  null
  
)

export default component.exports